// Top-left Google sign-in / sign-out controls + auth status messages.
// Extracted verbatim from App's render so the output is byte-identical.
function AuthButtons({ oauthState, onOauth, onSignout, apiConnectMessage, oauthMessage }) {
  return (
    <div className="top-left-actions">
      <button
        className={"api-connect-button oauth-button state-" + oauthState}
        disabled={oauthState === "pending"}
        onClick={onOauth}
        title="Start Google OAuth via satvik.prep.ai"
        type="button"
      >
        {oauthState === "pending" ? "loading..." : "Sign in with Google"}
      </button>
      <button
        className={"api-connect-button oauth-button"}
        onClick={onSignout}
        title="Sign out"
        type="button"
      >
        Sign out
      </button>
      {apiConnectMessage ? <div className="auth-status-message error">{apiConnectMessage}</div> : null}
      {oauthMessage ? <div className="auth-status-message error">{oauthMessage}</div> : null}
    </div>
  );
}

export default AuthButtons;
